import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// import store from '../store';
import { fetchAnswerSteaming, fetchGrammarCheckSuggestion } from './conversationApi';
import { getBillings, getTranslates } from './preferences/preferenceApi';
import { setTranslates } from './preferences/preferenceSlice';

const initialState = {
    queries: [],
    status: 'idle',
    conversationId: null
};

// const API_STREAMING = import.meta.env.VITE_API_STREAMING === 'true';
const API_STREAMING = true;

export const fetchAnswer = createAsyncThunk('fetchAnswer', async ({ question, language, languageTranslate }, { dispatch, getState }) => {
    const state = getState();
    if (API_STREAMING) {
        await fetchAnswerSteaming(question, '', language, languageTranslate, (event) => {
            const data = JSON.parse(event.data);
            // console.log('data------', data)
            // check if the 'end' event has been received
            if (data.type === 'end') {
                // set status to 'idle'
                getBillings();
                dispatch(conversationSlice.actions.setStatus('idle'));
                getTranslates()
                    .then((fetchedTranslates) => {
                        setTranslates(fetchedTranslates);
                        dispatch(setTranslates(fetchedTranslates));
                    })
                    .catch((error) => {
                        console.error('Failed to fetch conversations: ', error);
                    });
            } else {
                const result = data.answer;
                dispatch(
                    updateStreamingQuery({
                        index: state.conversation.queries.length - 1,
                        query: { response: result }
                    })
                );
            }
        });
    }

    return {
        conversationId: null,
        title: null,
        answer: '',
        query: question,
        result: '',
        sources: []
    };
});

export const fetchGrammarCheck = async (question) => {
    await fetchGrammarCheckSuggestion(question, (callback) => {
        return callback;
    });

    // return {
    //   conversationId: null,
    //   title: null,
    //   answer: '',
    //   query: question,
    //   result: '',
    //   sources: [],
    // };
};

export const conversationSlice = createSlice({
    name: 'conversation',
    initialState,
    reducers: {
        addQuery(state, action) {
            state.queries.push(action.payload);
        },
        setConversation(state, action) {
            state.queries = action.payload;
        },
        updateStreamingQuery(state, action) {
            const { index, query } = action.payload;
            if (query.response) {
                if (query.response === 'Đã vượt quá hạn mức cho phép. Vui lòng kiểm tra hóa đơn !') {
                    state.status = 'failed';
                    state.queries[state.queries.length - 1].error = 'Đã vượt quá hạn mức cho phép. Vui lòng kiểm tra hóa đơn !';
                } else {
                    state.queries[index].response = (state.queries[index].response || '') + query.response;
                }
            } else {
                state.queries[index] = {
                    ...state.queries[index],
                    ...query
                };
            }
        },

        setStatus(state, action) {
            state.status = action.payload;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchAnswer.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAnswer.rejected, (state, action) => {
                state.status = 'failed';
                state.queries[state.queries.length - 1].error = 'Đã có lỗi xảy ra. Vui lòng thử lại sau.';
            });
    }
});

export const selectQueries = (state) => state.conversation.queries;

export const selectStatus = (state) => state.conversation.status;

export const { addQuery, updateStreamingQuery, setConversation, setStatus } = conversationSlice.actions;
export default conversationSlice.reducer;
